import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDjxo18F8sBERp-A992L80eRrLdpq0m9-o",
    authDomain: "facebook-messenger-clone-7ece4.firebaseapp.com",
    databaseURL: "https://facebook-messenger-clone-7ece4.firebaseio.com",
    projectId: "facebook-messenger-clone-7ece4",
    storageBucket: "facebook-messenger-clone-7ece4.appspot.com",
    messagingSenderId: "997994369131",
    appId: "1:997994369131:web:078324f4f7c5c462ff612e",
    measurementId: "G-ZB94V03WME"
});

const db = firebaseApp.firestore();

export default db;
